import { render, staticRenderFns } from "./FoodDistributionRouteDetails.vue?vue&type=template&id=4f400e5a&"
import script from "./FoodDistributionRouteDetails.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionRouteDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports